export const links = {
  home: "/",
  about: "/about",
  recipes: "/recipes",
  shop: "/shop",
  blog: "/blog",
  contact: "/contact",
  privacyPolicy: "/privacy-policy",
};
